"use client"

import { Dices } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DicesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DicesIcon = component(Icon)({ as: Dices })
